import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import type { DialogContextItem } from "../DialogProvider";
type Props = {
  switcherItems: DialogContextItem[];
  currentContextIndex: number;
  houseName: string | null;
  onSelect: (index: number) => void;
  /** Override the outer positioning wrapper. Defaults to overlay inside its relative parent. */
  className?: string;
};
export function ContextSwitcher(t0) {
  const $ = _c(35);
  const {
    switcherItems,
    currentContextIndex,
    houseName,
    onSelect,
    className
  } = t0;
  const t1 = className ?? "absolute inset-0 z-30";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("pointer-events-none flex items-center justify-center", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== currentContextIndex || $[3] !== onSelect) {
    t3 = () => onSelect(currentContextIndex - 1);
    $[2] = currentContextIndex;
    $[3] = onSelect;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = currentContextIndex <= 0;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronLeft className="w-5 h-5" data-sentry-element="ChevronLeft" data-sentry-source-file="ContextSwitcher.tsx" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4) {
    t6 = <button type="button" onClick={t3} disabled={t4} aria-label="Previous" className="flex items-center justify-center w-9 h-9 rounded-full bg-white/15 hover:bg-white/30 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition-colors">{t5}</button>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== houseName) {
    t7 = houseName && <span className="text-xs font-semibold whitespace-nowrap">{houseName}</span>;
    $[9] = houseName;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== currentContextIndex || $[12] !== onSelect || $[13] !== switcherItems) {
    let t9;
    if ($[15] !== currentContextIndex || $[16] !== onSelect) {
      t9 = (item, i) => <button type="button" key={item.slug} onClick={() => onSelect(i)} aria-label={item.title} className={cn("h-2 rounded-full transition-all cursor-pointer", i === currentContextIndex ? "bg-white w-5" : "bg-white/40 hover:bg-white/60 w-2")} />;
      $[15] = currentContextIndex;
      $[16] = onSelect;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t8 = switcherItems.map(t9);
    $[11] = currentContextIndex;
    $[12] = onSelect;
    $[13] = switcherItems;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="flex items-center gap-2">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== currentContextIndex || $[21] !== onSelect) {
    t10 = () => onSelect(currentContextIndex + 1);
    $[20] = currentContextIndex;
    $[21] = onSelect;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = currentContextIndex >= switcherItems.length - 1;
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ChevronRight className="w-5 h-5" data-sentry-element="ChevronRight" data-sentry-source-file="ContextSwitcher.tsx" />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11) {
    t13 = <button type="button" onClick={t10} disabled={t11} aria-label="Next" className="flex items-center justify-center w-9 h-9 rounded-full bg-white/15 hover:bg-white/30 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition-colors">{t12}</button>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t6 || $[29] !== t7 || $[30] !== t9) {
    t14 = <div className="pointer-events-auto flex items-center gap-3 rounded-full bg-black/60 backdrop-blur-md px-3 py-1.5 shadow-xl text-white/90">{t6}{t7}{t9}{t13}</div>;
    $[27] = t13;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t2) {
    t15 = <div className={t2} data-sentry-component="ContextSwitcher" data-sentry-source-file="ContextSwitcher.tsx">{t14}</div>;
    $[32] = t14;
    $[33] = t2;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}